import { render, staticRenderFns } from "./SafetyPlanImprovementPlanRecordsTable.vue.html?vue&type=template&id=64a24de0&scoped=true&external"
import script from "./SafetyPlanImprovementPlanRecordsTable.vue.js?vue&type=script&lang=js&external"
export * from "./SafetyPlanImprovementPlanRecordsTable.vue.js?vue&type=script&lang=js&external"
import style0 from "./SafetyPlanImprovementPlanRecordsTable.vue.scss?vue&type=style&index=0&id=64a24de0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a24de0",
  null
  
)

export default component.exports